// src/store/slices/generalActivityLogSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import generalActivityLogApi from '../../api/generalActivityLogApi';

export const fetchGeneralActivityLogs = createAsyncThunk(
  'generalActivityLog/fetchAll',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const data = await generalActivityLogApi.getAll(filters);
      return data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.detail ||
        error.response?.data?.error ||
        'Failed to fetch activity logs';

      return rejectWithValue(message);
    }
  }
);

const initialPagination = {
  count: 0,
  current_page: 1,
  page_size: 10,
  total_pages: 1,
  next: null,
  previous: null,
};

const generalActivityLogSlice = createSlice({
  name: 'generalActivityLog',
  initialState: {
    logs: [],
    pagination: { ...initialPagination },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearGeneralLogs: (state) => {
      state.logs = [];
      state.pagination = { ...initialPagination };
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGeneralActivityLogs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchGeneralActivityLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.logs = action.payload.data || [];
        state.pagination = action.payload.pagination || { ...initialPagination };
      })
      .addCase(fetchGeneralActivityLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearGeneralLogs, clearError } = generalActivityLogSlice.actions;
export default generalActivityLogSlice.reducer;